import React, { Component } from 'react';
import './Fields.css'
import { Link } from 'react-router-dom';
import AuthService from '../services/auth';
import Api from '../services/api';
import { db } from '../firebase';

class SettingsDelete extends Component {

  constructor(props) {
    super(props);

    this.state = {
      fields: {
        confirm: false,
        keyword: '',
      },
    };
  }

  componentDidMount() {
    (new Api()).get('/users/current',{}, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          user: response.user,
        });
      });
  }

  handleSubmit(e) {
    e.preventDefault();
    const { user } = this.state;
    (new Api()).remove(`/users/${user.id}`,{} , AuthService.getAuthCookie())
      .then(response => {
        if(response.success) {
          db.deleteUserRooms(user.id)
            .then(() => {
              AuthService.logOut();
            });
        }
      });
  }

  handleFieldChange(e, name) {
    let fields = this.state.fields;

    fields[name] = e.target.value;

    if(name === 'confirm') {
      fields[name] = e.target.checked;
    }

    this.setState({ fields });
  }



  render() {
    const { title } = this.props;
    const { fields } = this.state;
    const canSubmit = fields.keyword.toLowerCase() === 'delete';
    return (
      <div className="col col-12 col-md-8">
        <div className="title">
          {title}
        </div>
        <form>
          <p>We are sorry to see you go :(</p>
          <p>You will be asked to confirm that you want to delete your account. There is no undo, so please be careful!</p>
          <p>Know that you will not be able to recover your account, or any information on it once you go through with the deletion.</p>
          <div className="field-container checkbox">
            <div className="row">
              <div className="col">
                <input
                  type="checkbox"
                  id="confirm"
                  name="confirm"
                  checked={fields.confirm}
                  value={true}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
                <label className="field-title" htmlFor="confirm">I want to delete my account</label>
              </div>
            </div>
          </div>
          {fields.confirm &&
          <div className="field-container text">
            <div className="row">
              <div className="col">
                <input
                  type="text"
                  id="keyword"
                  name="keyword"
                  placeholder="Type DELETE"
                  value={fields.keyword}
                  onChange={e => {this.handleFieldChange(e, e.target.name)}}
                />
              </div>
            </div>
          </div>}
          <Link
            to="/settings"
            className="cancel"
          >
            cancel
          </Link>
          <button
            className="btn submit"
            disabled={!canSubmit}
            onClick={(e) => {this.handleSubmit(e);}}
          >
            Delete
          </button>
        </form>
      </div>
    )
  }
}

export default SettingsDelete;


// WEBPACK FOOTER //
// ./src/components/SettingsDelete.js